module.exports = {

    Primary : function(type){ return { name: 'Primary' , type: type } }

}